import { Row, Col } from 'src/componentes/grid';
import { useIntl } from 'react-intl';

import Schema from './Schema';

import Input from 'src/componentes/input';
import Edit from 'src/componentes/edit/edit-dialog';
import ColaboradorLookup from 'src/lookups/colaborador';
import DatePicker from 'src/componentes/date-picker';
import FormularioComplementarOpcoesRespostaLookup from 'src/lookups/FormularioComplementarOpcoesRespostaLookup';
import useAuth from 'src/hooks/useAuth';
import { capitalizeFirstLetter } from 'src/utils/string';

function FormEdit({ model }) {
  const isDisabled = model.getModel('permissions').value
    ? !model.getModel('permissions').value.allowEdit
    : false;
  const { terms: resources } = useAuth();

  return (
    <>
      <Row>
        <Col md={3}>
          <DatePicker
            disabled={true}
            autoFormatDate={true}
            model={model.getModel('dataIndicacao')}
            required
          />
        </Col>
        <Col md={5}>
          <ColaboradorLookup
            disabled={true}
            model={model.getModel('indicador')}
            required
          />
        </Col>
        <Col md={5}>
          <ColaboradorLookup
            model={{
              label: capitalizeFirstLetter(resources.colaborador),
              value: model.getModel('colaborador').value,
              requestChange: model.getModel('colaborador').requestChange,
              errors: model.getModel('colaborador').errors,
            }}
            required
          />
        </Col>
        <Col md={5}>
          <FormularioComplementarOpcoesRespostaLookup
            model={model.getModel('tempoSucessao')}
            required
            data={{ campoId: 3 }}
          />
        </Col>
        <Col md={12}>
          <Input
            disabled={isDisabled}
            model={model.getModel('justificativa')}
            type="textarea"
            rows={4}
            required
          />
        </Col>
      </Row>
    </>
  );
}

function MapaSucessaoEditView({ parameters, ...rest }) {
  const intl = useIntl();
  const { terms: resources } = useAuth();
  return (
    <Edit
      respeitarAltura
      url="/MapaSucessao"
      title={
        parameters?.nomeCargo
          ? `${resources.cargo} - ${parameters?.nomeCargo}`
          : intl.formatMessage({ id: 'mapaSucessao' })
      }
      formComponent={FormEdit}
      schema={Schema}
      width="60%"
      height="450px"
      parameters={parameters}
      {...rest}
    ></Edit>
  );
}

export default MapaSucessaoEditView;
